import { ByClassesData } from './data-api-by-classes.type'
import { ByCustomersAndFundsData } from './data-api-by-customers-and-funds.type'
import { ByFundsData } from './data-api-by-funds.type'

export const isByClassesData = (data: ByClassesData | ByFundsData | ByCustomersAndFundsData): data is ByClassesData => {
  return ('summary' in data && 'details' in data)
}

export const isByFundsData = (data: ByClassesData | ByFundsData | ByCustomersAndFundsData): data is ByFundsData => {
  return ('details_group' in data && data.details_group === 'by_funds')
}

export const isByCustomersAndFundsData = (data: ByClassesData | ByFundsData | ByCustomersAndFundsData): data is ByCustomersAndFundsData => {
  return ('details_group' in data && data.details_group === 'by_customers_and_funds')
}
